import React from "react";
import { Layout, Row, Col, Card, Button } from "antd";
import "./ProductCreationProcess.scss";

const product_creation_tools = [
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/frame1.png",
        title: "User dashboard",
        desc: 'Manage your workflow seamlessly, keeping everything organized in one place. Track key metrics at a glance, including models in progress, images rendered, and  messages from your team.'

    },
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/frame2.png",
        title: "Collaboration tools",
        desc: 'Streamline communication with your team to finalize images effortlessly using our image markup tool. Easily leave comments, track feedback in threaded discussions, and receive notifications to stay updated.'
    },
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/frame3.png",
        title: "Asset manager",
        desc: 'Easily manage all your 3D assets in one place with our image library. Mark your favorites or use filters to quickly find images to collaborate on, download, and more.',
    },
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/frame4.png",
        title: "Cloud services",
        desc: 'Access, store, and share all your 3D models and assets securely with our cloud storage. Your libraries are always up-to-date across projects and teams.',
    }
];

const ToolsInfo = () => {

    return (
        <Row className="justify-in-center product-tool-creation-wrapper">
            <Card className="tool-card hide-desktop-tools">
                <h1 className="manrope f-38 lh-46 w-500 black-085 mb-24 text-center">Plus, tools that make your workflow seamless</h1>
                <p className="manrope f-20 lh-28 w-500 black-085 mb-40 text-center">
                    Our end-to-end workflow keeps projects on track and organized for the whole team.
                </p>
                <Row className="justify-space-between direction-flex roww">
                    {product_creation_tools.map((tool, index) => (
                        <Col span={12}>
                            {/* <div className={`image-with-background`}> */}
                                <img src={tool.img} className="tool-img" />
                            {/* </div> */}
                            <div className={`tool-container con-${index}`}>
                                <h3 className="manrope f-24 w-700 lh-32 black-085 mb-16">{tool.title}</h3>
                                <p className="manrope f-16 lh-24 w-500 black-085 mb-0">{tool.desc}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Button onClick={() => {
                        window.location.href = '/pricing'
                    }}
                        className={`manrope f-16 w-700 lh-24 white-button-black-border mt-40`}>
                        View pricing & plans
                    </Button>
                </Row>
            </Card>
           
        </Row>
    );
};

export default ToolsInfo;
